<img [src]="imgSource" [ngStyle]="{'height': height}" alt="Logo" />